import FacebookShareButton from '@/components/buttons/FacebookShareButton';
import { copyToClipboard } from '@/helpers/copyToClipboard';
import { convertHHMMSSToHM } from '@/helpers/timeHelpers';
import useToast from '@/hooks/useToast';
import { ICourseDetailResponse } from '@/interfaces/training.interface';
import { Divider } from 'design-system/components/Divider';
import { Icon } from 'design-system/components/Icon';
import { Typography } from 'design-system/components/Typography';
import { useContext } from 'react';
import { UseQueryResult } from 'react-query';
import { CourseDetailPermissionContext } from 'state/course/CourseDetailPermissionProvider';
import CourseActions from './CourseActions';

const CourseDetailInfo = () => {
  const { courseDetailQueryReturn } = useContext(CourseDetailPermissionContext);

  const { data: course } = courseDetailQueryReturn as UseQueryResult<
    ICourseDetailResponse,
    unknown
  >;

  const toast = useToast();
  const { certificateShortName, totalDuration, lessonCount } = course || {};

  const urlShare = typeof window !== 'undefined' ? window.location.href : '';

  const handleCopyLink = () => {
    copyToClipboard(urlShare, () =>
      toast('Đã sao chép liên kết thành công', 'success')
    );
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <Typography
            variant="body3"
            className="text-Text/LightBackground/Secondary"
          >
            Tổng số bài học:
          </Typography>
          <Typography variant="body3">{lessonCount}</Typography>
        </div>
        {certificateShortName && (
          <div className="flex items-center justify-between">
            <Typography
              variant="body3"
              className="text-Text/LightBackground/Secondary"
            >
              Loại chứng chỉ:
            </Typography>
            <Typography variant="body3">{certificateShortName}</Typography>
          </div>
        )}
        <div className="flex items-center justify-between">
          <Typography
            variant="body3"
            className="text-Text/LightBackground/Secondary"
          >
            Tổng thời gian:
          </Typography>
          <Typography variant="body3">
            {convertHHMMSSToHM(totalDuration || '00:00:00')}
          </Typography>
        </div>
      </div>
      <Divider />
      <CourseActions />
      <Divider />
      <div className="flex items-center justify-center gap-2 text-Text/LightBackground/Secondary">
        <Typography variant="label">Chia sẻ:</Typography>
        <FacebookShareButton href={urlShare} />
        <Icon
          iconName="link"
          className="cursor-pointer"
          onClick={handleCopyLink}
        />
      </div>
    </div>
  );
};

export default CourseDetailInfo;
